import React, { Component } from "react";
import ProductHeader from "../ProductDetails/ProductHeader";
import { connect } from "react-redux";
import instance from "../../store/actions/instance";
import { CircularProgress } from "@material-ui/core";
import { ReactComponent as Empty } from "./assets/empty.svg";
import { ReactComponent as History } from "./assets/history.svg";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import moment from "moment";
import { timeConvert } from "../Branches/ContactPageTools";
import {
  add_to_cart,
  remove_from_cart,
  clearUsedComponents,
} from "../../store/actions";
import {
  check_required_options,
  getAllowableInventory,
} from "../../store/actions/store";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import HelpIcon from "@material-ui/icons/Help";
import Tooltip from "@material-ui/core/Tooltip";
import Popover from "@material-ui/core/Popover";
import { preciseNumber } from "../../store/reducers/cart";
import { getParentCategories } from "../Menu/Helpers";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import {
  getProductInventory,
  getProductUsedComponents,
} from "../../store/reducers/store";

export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class index extends Component {
  state = {
    loading: false,
    pastOrders: [],
    search: "",
    searchLoading: false,
    reorderLoading: false,
    tooltipOpen: false,
    alertOpen: false,
  };
  componentDidMount = () => {
    this.fetchPastOrders();
  };
  handleSearchChange = (e) => {
    this.setState({ search: e.target.value });

    if (
      this.state.pastOrders.filter((po) =>
        po.tracking_id.toLowerCase().includes(e.target.value.toLowerCase())
      ).length == 0 &&
      e.target.value &&
      e.target.value.trim().length == 9 &&
      /[A-Z]*-[1-9]*/g.test(e.target.value)
    ) {
      this.fetchPastOrders(e.target.value);
    }
  };

  getTotalPrice = (sum, options) => {
    let selected_option = {};
    let optionSum = 0;
    const quantity = 1;

    let quantityExcludedOptionsTotal = 0;

    for (let key of Object.keys(options)) {
      optionSum = 0;
      selected_option = options[key].selectedOptions;

      if (isEmpty(selected_option)) delete options[key];
      else {
        for (let selected_key of Object.keys(selected_option)) {
          optionSum +=
            selected_option[selected_key].quantity *
            selected_option[selected_key].price;
        }
        if (options[key].quantityExclusive) {
          quantityExcludedOptionsTotal = preciseNumber(
            quantityExcludedOptionsTotal + optionSum
          );
        } else {
          sum += optionSum * quantity;
        }
      }
    }

    return {
      total_price: preciseNumber(sum),
      quantityExcludedOptionsTotal: preciseNumber(quantityExcludedOptionsTotal),
    };
  };
  async fetchPastOrders(search) {
    // Search is a tracking id
    if (!search) this.setState({ loading: true });
    else this.setState({ searchLoading: true });
    let branch_id = this.props.branch.branch;
    let used_components = this.props.used_components;
    const res = await instance.post(`/get_past_orders/`, {
      promises: search || this.props.pastOrders,
      is_search: !!search,
      branch_id: branch_id,
      used_components: used_components,
    });

    if (
      res.data.length == 1 &&
      search &&
      !this.props.pastOrders.includes(res.data[0].id)
    ) {
      this.props.addToPastOrders(res.data[0].id);
    }

    this.props.storePastOrderProducts(res.data);
    this.setState({ pastOrders: [...this.state.pastOrders, ...res.data] });
    if (!search) this.setState({ loading: false });
    else this.setState({ searchLoading: false });
  }
  EmptyCart = () => {
    const length = this.props.cart.length;
    for (let i = 0; i < length; i++) {
      this.props.remove_from_cart(0, this.props.cart[0]);
    }
    this.props.clearUsedComponents();
  };
  getOptions = (options, store_product, itemQuantity) => {
    const { used_components } = this.props;
    let selectedOptions = {};
    let group = null;
    let choice = null;
    let option = null;
    let optionUsedComponents = {};
    for (let i = 0; i < options.length; i++) {
      option = options[i];

      choice = option.product_option;

      group = option.group
        ? choice.option_id + "-" + option.group
        : choice.option_id;
      let store_choice = null;
      let store_option = null;
      if (!isEmpty(store_product.options)) {
        store_option = store_product.options.find(
          (G) => G.id === parseInt(group)
        );
        if (
          option.group &&
          !store_product.options_groups.some(
            (og) => og.id == parseInt(option.group)
          )
        ) {
          store_option = null;
        }
        if (!store_option) return "remove";
        store_choice = store_option.choices.find((o) => o.id === choice.id);
      }
      if (!store_choice) return "remove";

      if (store_choice.inventory !== null && store_choice.related_product) {
        const modifierQuantity =
          (!store_option.quantity_exclusive &&
            option.quantity * itemQuantity) ||
          option.quantity;

        optionUsedComponents[store_choice.related_product.id] =
          (optionUsedComponents[store_choice.related_product.id] || 0) +
          modifierQuantity;

        const usedAmount =
          (this.props.used_components[store_choice.related_product.id] || 0) +
          optionUsedComponents[store_choice.related_product.id];

        if (
          getProductInventory(store_choice.related_product, used_components) -
            usedAmount <
          0
        ) {
          return "remove";
        }
      }

      if (!selectedOptions[group]) {
        selectedOptions[group] = {
          selected: option.quantity,
          quantityExclusive: store_option.quantity_exclusive,
          selectedOptions: {
            [choice.id]: {
              quantity: option.quantity,
              price: store_choice.price,
              related_product: store_choice.related_product,
              modifier: store_choice.modifier,
              maxInventory: store_choice.inventory,
              preparationTime: store_choice.preparation_time,
            },
          },
        };
      } else {
        selectedOptions[group].selected += option.quantity;
        selectedOptions[group].selectedOptions[choice.id] = {
          quantity: option.quantity,
          price: store_choice.price,
          related_product: store_choice.related_product,
          modifier: store_choice.modifier,
          maxInventory: store_choice.inventory,
          preparationTime: store_choice.preparation_time,
        };
      }
    }

    if (check_required_options(store_product, selectedOptions)) {
      return selectedOptions;
    }
    return "remove";
  };
  FindProduct = (pitem) => {
    const { used_components } = this.props;
    try {
      let item = pitem.product;

      let store_product = this.props.store.categories.find(
        (category) => category.id === item.category_id
      );

      if (pitem.parent_id) {
        store_product = store_product.products
          .find((parent) => parent.id === pitem.parent_id)
          .children.find((product) => product.id === pitem.product_id);
      } else {
        store_product = store_product.products.find(
          (product) => product.id === pitem.product_id
        );
      }
      if (store_product) {
        if (["produced", "digital"].includes(store_product.type_of_product)) {
          return { store_product, quantity: pitem.quantity };
        } else if (
          ["stocked", "composite"].includes(store_product.type_of_product) &&
          getProductInventory(store_product, used_components) >=
            store_product.min_addable_quantity
        ) {
          let inventory = pitem.quantity;
          const productAvailableInventory = getProductInventory(
            store_product,
            used_components
          );

          if (pitem.quantity > productAvailableInventory) {
            inventory = getAllowableInventory(
              productAvailableInventory,
              store_product.increments,
              store_product.min_addable_quantity
            );
          }
          if (inventory < store_product.min_addable_quantity) {
            return false;
          }

          return {
            store_product,
            quantity: inventory,
          };
        } else if (store_product.type_of_product === "bookable") {
          let inventory = store_product.booking_slots.find(
            (slot) => slot.id === pitem.booking_original_slot_id
          ).inventory;
          if (inventory !== 0) {
            return {
              store_product,
              quantity: Math.min(pitem.quantity, inventory),
            };
          }
        }
      }
    } catch (err) {
      return false;
    }
    return false;
  };
  handleReOrder = async (p) => {
    const { address, store, cart, settings } = this.props;

    try {
      this.setState({ reorderLoading: true });
      let branch_id = this.props.branch.branch;
      let used_components = this.props.used_components;
      const res = await instance.post(`/get_past_orders/`, {
        promises: p.tracking_id,
        is_search: true,
        branch_id: branch_id,
        used_components: used_components,
        fetch_items: true,
      });
      try {
        if (res.data[0].lat && res.data[0].lng)
          this.props.modifyAddress({
            lat: parseFloat(res.data[0].lat),
            lng: parseFloat(res.data[0].lng),
          });
      } catch (e) {}

      this.props.storePastOrderProducts(res.data);
      p.items = res.data[0].items;
    } catch (err) {}
    this.setState({ reorderLoading: false });
    let item = null;

    this.EmptyCart();
    let nonMingledCategory = null;
    let addedItem = false;
    for (let i = 0; i < p.items.length; i++) {
      item = p.items[i];
      let { store_product, quantity } = this.FindProduct(item);

      if (store_product) {
        if (
          store_product.pickup_only &&
          (!address || address.selectedDeliveryType !== 1)
        ) {
          continue;
        }
        if (
          store_product.delivery_only &&
          (!address || address.selectedDeliveryType !== 0)
        ) {
          continue;
        }
        let options = this.getOptions(item.options, store_product, quantity);

        let parentCategories = null;
        if (store_product.category_is_child) {
          parentCategories = getParentCategories(
            store_product.category_id,
            store.categories
          );
        }

        if (nonMingledCategory) {
          if (
            store_product.category_id !== nonMingledCategory &&
            parentCategories?.nonMingledParentCategory !== nonMingledCategory
          ) {
            continue;
          }
        } else if (addedItem) {
          if (
            store_product.category_no_mingling ||
            parentCategories?.nonMingledParentCategory
          ) {
            continue;
          }
        } else {
          if (parentCategories?.nonMingledParentCategory) {
            nonMingledCategory = parentCategories?.nonMingledParentCategory;
          } else if (store_product.category_no_mingling) {
            nonMingledCategory = store_product.category_id;
          }
        }

        if (options !== "remove") {
          let product = {
            id: store_product.id,
            quantity: quantity,
            category: store_product.category,
            category_id: store_product.category_id,
            components: store_product.components,
            options: options,
            booking_slot: item.booking_original_slot_id,
            parent: store_product.parent,
            ...this.getTotalPrice(store_product.price, options),
            price: store_product.price,
            is_delivered: store_product.is_delivered,
            charge_delivery: store_product.charge_delivery,
            special_request: item.special_remarks,
            preparation_time: store_product.preparation_time,
            preparation_time_threshold:
              store_product.preparation_time_threshold,
            pickup_only: store_product.pickup_only,
            delivery_only: store_product.delivery_only,
            is_preordered: false,
            extraFields: {},
            name: store_product.name,
            category_is_child: store_product.category_is_child,
            category_no_mingling: store_product.category_no_mingling,
            parentCategories: parentCategories,
            cash_only:
              settings.enable_cash &&
              settings.allow_cash &&
              settings.enable_online_payments &&
              settings.enable_payments
                ? store_product.cash_only
                : false,
            credit_only:
              settings.enable_cash &&
              settings.allow_cash &&
              settings.enable_online_payments &&
              settings.enable_payments
                ? store_product.credit_only
                : false,
            excludeVat: store_product.exclude_from_vat,
            // productUsedComponents: getProductUsedComponents(product),
          };
          await this.props.AddToCart(product);
          addedItem = true;
        }
      } else {
        continue;
      }
    }
    if (!this.props.cart.length) {
      this.setState({ alertOpen: true });
    } else {
      this.props.history.replace("/checkout/confirmation");
    }
  };
  render() {
    const { themeColor, language, settings } = this.props;
    const customTexts = settings.custom_texts;
    const currency =
      language == "english"
        ? settings.base_currency
        : settings.base_currency_local;

    let listItems;
    if (this.state.pastOrders) {
      listItems = this.state.pastOrders
        .filter((po) =>
          po.tracking_id.toLowerCase().includes(this.state.search.toLowerCase())
        )
        .map((p, indx) => {
          let total = 0;
          let secondaryItems = [];

          secondaryItems = secondaryItems.concat(
            p.is_delivery ? (
              <p className={"mb-0 mt-2"}>
                {language == "english" ? "Delivery:" : "التوصيل:"}{" "}
                {p.delivery_rate.toFixed(settings.base_currency_decimals)}{" "}
                {currency}
              </p>
            ) : (
              <p className={"mb-0 mt-2"}>
                {language == "english"
                  ? `${customTexts.pickup} order`
                  : `طلب ${customTexts.pickup_ar}`}
              </p>
            )
          );

          secondaryItems = secondaryItems.concat(
            <p>
              {language == "english" ? "Total: " : "المجموع: "}{" "}
              {parseFloat(p.total).toFixed(settings.base_currency_decimals)}{" "}
              {currency}
            </p>
          );
          return (
            <>
              <ListItem style={{ minHeight: 120 }}>
                <ListItemText
                  style={{
                    textAlign: language == "english" ? "left" : "right",
                  }}
                  primary={
                    <>
                      {p.tracking_id}
                      <span
                        dir={language == "english" ? "ltr" : "rtl"}
                        className={language == "english" ? "ml-2" : "mr-2"}
                      >
                        {moment(p.created, "YYYY-MM-DD").format(
                          language == "english" ? "DD/MMM" : "MM/DD"
                        )}
                      </span>
                      <span
                        dir={language == "english" ? "ltr" : "rtl"}
                        className={language == "english" ? "ml-2" : "mr-2"}
                      >
                        {timeConvert(
                          moment(p.created).format("HH:mm:ss"),
                          language
                        )}
                      </span>
                    </>
                  }
                  secondary={secondaryItems}
                />
                <div
                  className={language == "english" ? "text-right" : "text-left"}
                  style={{ display: "block" }}
                >
                  {this.props.store.settings.enable_tracking && (
                    <Button
                      className="px-1 py-1 mb-2"
                      variant="contained"
                      disableElevation
                      color="primary"
                      onClick={() =>
                        this.props.history.push(
                          `/track/order/${p.tracking_id}`,
                          {
                            fromPastOrders: true,
                          }
                        )
                      }
                      style={{
                        color: themeColor,
                        padding: 0,
                        width: 100,
                        color: "white",
                        display: "block",
                      }}
                    >
                      {language == "english" ? "Track Order" : "تتبع الطلب"}
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    disableElevation
                    disabled={p.has_services}
                    color="primary"
                    className="px-1 py-1 mt-1"
                    onClick={() => this.handleReOrder(p)}
                    style={{
                      color: themeColor,
                      padding: 0,
                      width: 100,
                      color: "white",
                      display: "block",
                    }}
                  >
                    {language == "english" ? "Order Again" : "اعادة الطلب"}
                  </Button>
                  {p.has_services && (
                    <p
                      className="mb-0 text-center mt-2"
                      style={{ color: themeColor }}
                    >
                      <HelpIcon
                        onClick={(e) =>
                          this.setState({ tooltipOpen: e.currentTarget })
                        }
                      />
                      <Popover
                        PaperProps={{ style: { padding: 10 } }}
                        id={
                          this.state.tooltipOpen ? "simple-popover" : undefined
                        }
                        open={Boolean(this.state.tooltipOpen)}
                        anchorEl={this.state.tooltipOpen}
                        onClose={() => this.setState({ tooltipOpen: null })}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                      >
                        <div style={{ padding: 10 }}>
                          {language == "english"
                            ? "This order contains a service booking and cannot be ordered again"
                            : "هذا الطلب يحتوي على حجز لخدمة ولا يمكن اعادة طلبه"}
                        </div>
                      </Popover>
                    </p>
                  )}
                </div>
              </ListItem>
              {indx != this.state.pastOrders.length - 1 && <Divider />}
            </>
          );
        });
    }
    const { alertOpen } = this.state;
    return (
      <div style={{ backgroundColor: "white", minHeight: window.innerHeight }}>
        <ProductHeader />
        <div style={{ height: 50 }}></div>
        <Snackbar
          open={alertOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ alertOpen: false })}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert
            onClose={() => this.setState({ alertOpen: false })}
            severity="error"
          >
            {language == "english"
              ? "Order cant be placed because all products are not available"
              : "لا يمكن إعادة الطلب لأن جميع المنتجات لم تعد متوفره"}
          </Alert>
        </Snackbar>
        <h4
          className={
            language == "english" ? "text-left pl-3" : "text-right pr-3"
          }
          style={{ fontFamily: language == "english" ? "Quicksand" : "Cairo" }}
        >
          {language == "english" ? "Your past orders" : "طلباتك السابقة"}
          {this.state.pastOrders.length > 0 && (
            <span> ({this.state.pastOrders.length})</span>
          )}
        </h4>

        {(this.state.loading || this.state.reorderLoading) && (
          <CircularProgress color="primary" style={{ marginTop: 20 }} />
        )}
        {!this.state.pastOrders.length && !this.state.loading && (
          <>
            <Empty width="100" height="100" className="mt-5" />
            <p className="mt-3">
              {language == "english"
                ? "You don't have any past orders"
                : "ليس لديك اي طلبات سابقة"}
            </p>
            <p
              style={{
                width: "90%",
                margin: "auto",
                marginTop: 20,
                textAlign: language == "english" ? "left" : "right",
              }}
            >
              {language == "english"
                ? "Have a tracking code? Enter it below"
                : "لديك رقم تتبع؟ ادخله ادناه"}
            </p>

            <TextField
              className="mt-2 "
              onChange={this.handleSearchChange}
              id="input-with-icon-textfield"
              label={
                language == "english"
                  ? "Enter your tracking code"
                  : "ادخل رقم التتبع"
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                style: {
                  height: "43px",
                },
                dir: language == "english" ? "ltr" : "rtl",
              }}
              inputProps={{
                style: {
                  paddingRight: language == "arabic" && 10,
                },
              }}
              InputLabelProps={{
                style: {
                  right: language == "arabic" && -20,
                  left: language == "arabic" && "auto",
                },
                dir: language == "english" ? "ltr" : "rtl",
              }}
              style={{ width: "90%" }}
            />
          </>
        )}

        {this.state.pastOrders.length &&
        !this.state.loading &&
        !this.state.reorderLoading ? (
          <>
            <div
              className="row w-100 m-0 mt-4"
              style={{ direction: language == "english" ? "ltr" : "rtl" }}
            >
              <div className="col-3">
                <History style={{ width: 60, height: 60 }} />
              </div>
              <div
                className="col-9"
                style={{
                  paddingLeft: language == "english" && 0,
                  paddingRight: language == "arabic" && 0,
                }}
              >
                <TextField
                  className=""
                  onChange={this.handleSearchChange}
                  id="input-with-icon-textfield"
                  label={
                    language == "english"
                      ? "Enter your tracking code"
                      : "ابحث عن طريق رقم التتبع"
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    style: {
                      height: "43px",
                    },
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                  inputProps={{
                    style: {
                      paddingRight: language == "arabic" && 10,
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      transformOrigin:
                        language == "english" ? "top left" : "top right",
                      right: language == "arabic" ? 0 : "unset",
                      left: language == "english" ? 0 : "unset",
                    },
                  }}
                  style={{ width: "90%" }}
                />
              </div>
            </div>
            {!this.state.searchLoading ? (
              <List dense={false} dir={language == "english" ? "ltr" : "rtl"}>
                {listItems}
              </List>
            ) : (
              <CircularProgress color="primary" style={{ marginTop: 20 }} />
            )}
          </>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    pastOrders: state.PastOrders.pastOrders,
    themeColor: state.store.store.settings.dark,
    language: state.store.language,
    cart: state.cart.cart,
    settings: state.store.store.settings,
    address: state.customers.address,
    branch: state.branch,
    used_components: state.store.used_components,
    non_mingled_category: state.cart.non_mingled_category,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddToCart: (product, history) => dispatch(add_to_cart(product, history)),
    remove_from_cart: (item_index, item) =>
      dispatch(remove_from_cart(item_index, item)),
    storePastOrderProducts: (pastOrders) =>
      dispatch({ type: "STORE_PAST_ORDER_PRODUCTS", payload: pastOrders }),
    addToPastOrders: (newID) =>
      dispatch({ type: "ADD_TO_PAST_ORDERS", payload: newID }),
    clearUsedComponents: () => dispatch(clearUsedComponents()),
    modifyAddress: (address) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: address }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
